var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('h1',[_vm._v("Categorias")]),_c('TreeBrowser',{attrs:{"node":_vm.root}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }